import { Stage } from '@/components/operations/types';

export interface OperationSummary {
  stage: Stage;
  isComplete: boolean;
}

export interface WorkOrderConfig {
  // Identity / dimensions
  unitName: string;
  width: string;
  height: string;
  // Inclusion flags
  completeUnit: boolean;
  buildoutIncluded: boolean;
  includesHousing: boolean;
  includesSideTracks: boolean;
  includesHemBar: boolean;
  includesFabric: boolean;
  includesMotorTube: boolean;
  // Housing
  housingType: string;
  housingSize: string;
  // Motor
  motorType: string;
  driveSide: string;
  powerCord: string;
  // Fabric
  fabricType: string;
  seam: string;
  fabricHeightAdjustment: string;
  rotateFabric: string;
  zipperColor: string;
  // Hem bar
  hemBarType: string;
  hemBarCapColor: string;
  pileBrush: string;
  // Retention / side tracks
  retention: string;
  retentionLeft: string;
  retentionRight: string;
  retentionCapColor: string;
  cutTracks: boolean;
  // Frame / colors
  frameColorVaries: boolean;
  frameColor: string;
  endCapFrameColor: string;
  buildoutFrameColor: string;
  hemBarFrameColor: string;
  housingFrameColor: string;
  retentionFrameColor: string;
  // Buildout details
  buildoutMaterial: string;
  buildoutQuantity: string;
  buildoutLength: string;
  // Extras
  cfTube: boolean;
  clearWindow: boolean;
  clearWindowAmount: string;
  clearWindowUnit: string;
  preDrilledTracks: boolean;
  // Scheduling
  schedulePriority: string;
  scheduleFrame: string;
  scheduleFabric: string;
  // Status
  woStatus: string;
  isBuilt: boolean;
}

export const EMPTY_WORK_ORDER_CONFIG: WorkOrderConfig = {
  unitName: '', width: '', height: '',
  completeUnit: false, buildoutIncluded: false,
  includesHousing: false, includesSideTracks: false, includesHemBar: false,
  includesFabric: false, includesMotorTube: false,
  housingType: '', housingSize: '',
  motorType: '', driveSide: '', powerCord: '',
  fabricType: '', seam: '', fabricHeightAdjustment: '', rotateFabric: '', zipperColor: '',
  hemBarType: '', hemBarCapColor: '', pileBrush: '',
  retention: '', retentionLeft: '', retentionRight: '', retentionCapColor: '', cutTracks: false,
  frameColorVaries: false, frameColor: '',
  endCapFrameColor: '', buildoutFrameColor: '', hemBarFrameColor: '', housingFrameColor: '', retentionFrameColor: '',
  buildoutMaterial: '', buildoutQuantity: '', buildoutLength: '',
  cfTube: false, clearWindow: false, clearWindowAmount: '', clearWindowUnit: '', preDrilledTracks: false,
  schedulePriority: '', scheduleFrame: '', scheduleFabric: '',
  woStatus: '', isBuilt: false,
};

export type WorkOrderOutcome = 'Active' | 'Built' | 'Closed Unbuilt';

export type WorkOrderStatus = 'Open' | 'Ready' | 'Built' | 'Closed Unbuilt';

export function deriveWorkOrderStatus(
  outcome: WorkOrderOutcome,
  allComplete: boolean
): WorkOrderStatus {
  if (outcome === 'Built') return 'Built';
  if (outcome === 'Closed Unbuilt') return 'Closed Unbuilt';
  return allComplete ? 'Ready' : 'Open';
}

export interface WorkOrderRow {
  id: string;
  workOrderId: string;
  orderNumber: string;
  salesOrderId: string;
  customer: string;
  fabricType: string;
  frameColor: string;
  isTKS0026: boolean;
  date: string;
  dateTs: number;
  location: string;
  operations: OperationSummary[];
  opsTotal: number;
  opsComplete: number;
  opsPercent: number;
  nextStage: string;
  allComplete: boolean;
  kittingComplete: boolean;
  fabricComplete: boolean;
  metalComplete: boolean;
  finalAssemblyComplete: boolean;
  outcome: WorkOrderOutcome;
  status: WorkOrderStatus;
  builtAt: string;
  builtTs: number;
  completedAt: string;
  completedTs: number;
  config: WorkOrderConfig;
}
